import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  customConvertIntoSelect2OptionsClasses,
  getFetchOptions,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";

const ManageSelfies = () => {
  const teacherId = localStorage.getItem("userId");
  const [challengeOptions, setChallengeOptions] = useState([]);
  const [selectedChallenge, setSelectedChallenge] = useState(null);
  const [classOptions, setClassOptions] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [studentOptions, setStudentOptions] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [pointList, setPointsList] = useState([]);

  const breadcrumb = {
    current_section: "Selfies",
    sections: [
      { name: "Gestione Punti", route_name: null, params: [] },
      { name: "Selfies", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchChallenges = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${
            axios.defaults.baseBFFUrl
          }/fe/getAllChallenges?schoolId=${localStorage.getItem(
            "userSchoolId"
          )}&teacherId=${teacherId}`,
          fetchOptions
        );
        const result = await response.json();
        setChallengeOptions(convertIntoSelect2Options(result, "id", "titolo"));
      } catch (error) {
        console.error(error);
      }
    };

    fetchChallenges();
  }, []);

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getClassesOnChallengeFromTeacher?teacherId=${teacherId}&challengeId=${selectedChallenge}`,
          fetchOptions
        );
        const result = await response.json();
        setClassOptions(
          customConvertIntoSelect2OptionsClasses(
            result.classes,
            "idclassi",
            "classe",
            "sezione"
          )
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchClasses();
  }, [selectedChallenge]);

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getStudentsOnChallengeByClass?classId=${selectedClass}&challengeId=${selectedChallenge}`,
          fetchOptions
        );
        const result = await response.json();
        setStudentOptions(
          customConvertIntoSelect2OptionsClasses(
            result.students,
            "id",
            "nome",
            "cognome"
          )
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchStudents();
  }, [selectedClass]);

  const handleSearch = () => {
    const fetchPoints = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getStudentSelfies?userId=${selectedStudent}&challengeId=${selectedChallenge}`,
          fetchOptions
        );
        const result = await response.json();
        setPointsList(result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchPoints();
  };

  const handlePointChange = (index, newValue) => {
    const updatedPoints = [...pointList];
    updatedPoints[index].punteggi_punti = newValue;
    setPointsList(updatedPoints);
  };

  const handleSavePoint = async (point) => {
    try {
      const fetchOptions = getFetchOptions(
        "application/json",
        {
          pointsId: point.idpunteggi,
          newScore: Number(point.punteggi_punti),
        },
        "POST"
      );

      const response = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/updateSelfiePoints`,
        fetchOptions
      );

      if (!response.ok) throw new Error("Errore durante il salvataggio");

      alert("Punteggio aggiornato con successo!");
    } catch (error) {
      console.error(error);
      alert("Errore nel salvataggio del punteggio");
    }
  };

  const handleDeletePoint = async (point) => {
    if (!window.confirm("Sei sicuro di voler eliminare questo punteggio?")) {
      return;
    }

    try {
      const fetchOptions = getFetchOptions("application/json", [], "DELETE");

      const response = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/deleteSelfie?pointsId=${point.idpunteggi}`,
        fetchOptions
      );

      if (!response.ok) throw new Error("Errore durante l'eliminazione");

      alert("Punteggio eliminato con successo!");

      const fetchPoints = async () => {
        try {
          const fetchOptions = getFetchOptions(
            "application/x-www-form-urlencoded",
            [],
            "GET"
          );
          const response = await fetch(
            `${axios.defaults.baseBFFUrl}/fe/getStudentChallengeEntriesSelfies?studentId=${selectedStudent}&challengeId=${selectedChallenge}`,
            fetchOptions
          );
          const result = await response.json();
          setPointsList(result);
        } catch (error) {
          console.error(error);
        }
      };

      fetchPoints();
    } catch (error) {
      console.error(error);
      alert("Errore nell'eliminazione del punteggio");
    }
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      {/* Filters */}
      <div className="card custom-card">
        <div className="card-header">Ricerca</div>
        <div className="card-body">
          <div className="row align-items-end">
            <div className="col-12 col-xl-3">
              <Select
                options={challengeOptions}
                id="challenge"
                name="challenge"
                value={challengeOptions?.filter(function (option) {
                  return option.value === selectedChallenge;
                })}
                onChange={(option) => {
                  setSelectedChallenge(option?.value);
                  setSelectedClass(null);
                  setSelectedStudent(null);
                }}
                classNames={"form-control"}
                placeholder="Scegli challenge..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col-12 col-xl-4">
              <Select
                options={classOptions}
                id="classi"
                name="classi"
                value={classOptions?.filter(function (option) {
                  return option.value === selectedClass;
                })}
                onChange={(option) => {
                  setSelectedClass(option?.value);
                }}
                classNames={"form-control"}
                placeholder="Scegli classe..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col-12 col-xl-3">
              <Select
                options={studentOptions}
                id="studenti"
                name="studenti"
                value={studentOptions?.filter(function (option) {
                  return option.value === selectedStudent;
                })}
                onChange={(option) => {
                  setSelectedStudent(option?.value);
                }}
                classNames={"form-control"}
                placeholder="Scegli studente..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col-12 col-xl-2">
              <button
                id="btnSearch"
                name="btnSearch"
                className="btn btn-success searchButton"
                type="button"
                onClick={handleSearch}
              >
                &nbsp;Cerca
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Points List */}
      <div className="card custom-card">
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>
              Elenco Punteggi Selfie -{" "}
              {studentOptions?.filter(function (option) {
                return option.value === selectedStudent;
              })?.[0]?.label || "Nessuno studente selezionato"}
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Anteprima</th>
                  <th>Punteggio</th>
                  <th>Descrizione</th>
                  <th>Data Invio</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {pointList.length > 0 ? (
                  pointList.map((point, index) => (
                    <tr key={point.idpunteggi}>
                      <td>
                        <a
                          href={point.studentDoc?.linkFirebase}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={point.studentDoc?.linkFirebase}
                            alt="Anteprima"
                            style={{ width: "100px", height: "auto" }}
                          />
                        </a>
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={point.punteggi_punti}
                          onChange={(e) =>
                            handlePointChange(index, e.target.value)
                          }
                          style={{ width: "80px" }}
                        />
                      </td>
                      <td>{point.studentDoc?.descrizione}</td>
                      <td>
                        {new Date(point.punteggi_data).toLocaleDateString(
                          "it-IT"
                        )}
                      </td>
                      <td>
                        <div className="btn-list">
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() => handleSavePoint(point)}
                          >
                            <i className="align-middle bi bi-floppy"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDeletePoint(point)}
                          >
                            <i className="align-middle bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      Nessun dato disponibile
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageSelfies;
